<template>
  <el-card>
    <el-form ref="form" :model="form" :rules="rules" label-width="220px">
      <el-form-item label="手机号：" required>
        <el-input v-model="form.baobmobile" disabled>
          <template #append>
            <el-button style="padding: 0 8px" type="text" @click="getShopList">
              获取店铺列表
            </el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="爆版店铺：" prop="shopId">
            <el-select
              v-model="form.shopId"
              placeholder="请选择爆版店铺"
              @change="verifyShopInfo"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in shop_list"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="营业类型：" required>
            <el-select
              v-model="form.business_type"
              filterable
              placeholder="营业类型"
              disabled
            >
              <el-option
                v-for="item in business_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商家名称：" prop="supply_name" required>
            <el-input v-model="form.supply_name" disabled />
          </el-form-item>
          <el-form-item label="品牌名称：" prop="brand_name" required>
            <el-input v-model="form.brand_name" disabled />
          </el-form-item>
          <el-form-item label="城市" prop="city" required>
            <el-select
              v-model="form.city"
              filterable
              placeholder="城市"
              @change="handleSelectCity($event, true)"
            >
              <el-option
                v-for="item in citys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="市场：" prop="market_id">
            <el-select
              v-model="form.market_id"
              filterable
              placeholder="市场"
              @change="onMainMarketChange($event, true)"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in marketList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="子市场：" prop="market_sub_id">
            <el-select
              v-model="form.market_sub_id"
              filterable
              placeholder="子市场"
              @change="onSubMarketChange"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in subMarketList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="楼层：" prop="supply_floor" required>
            <el-input v-model="form.supply_floor" disabled />
          </el-form-item>
          <el-form-item label="区域：" prop="supply_area" required>
            <el-input v-model="form.supply_area" disabled />
          </el-form-item>
          <el-form-item label="门牌号：" prop="supplier_num" required>
            <el-input v-model="form.supplier_num" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="attributable_market_id">
            <template #label>
              业绩归属市场
              <el-tooltip effect="light">
                <template #content>
                  用于统计公司内部各市场部门的业绩销售情况
                </template>
                <i class="el-icon-question" />
              </el-tooltip>
            </template>
            <el-select
              v-model="form.attributable_market_id"
              filterable
              placeholder="业绩归属市场"
              @change="handleSetAttributableSubMarket($event, true)"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in performanceMarketList"
                :key="item.attributable_market_id"
                :label="item.attributable_market_name"
                :value="item.attributable_market_id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="买手组" prop="picker_group_id">
            <el-select
              v-model="form.picker_group_id"
              filterable
              placeholder="买手组"
              @change="onMsChange"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in msOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="买手" prop="picker_group_member_id">
            <el-select
              v-model="form.picker_group_member_id"
              filterable
              placeholder="买手"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in msMemberOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="邀请码：" prop="registration_code">
            <el-input v-model="form.registration_code" disabled />
          </el-form-item>

          <el-form-item label="代采组" prop="pgid">
            <el-select
              v-model="form.pgid"
              filterable
              placeholder="代采组"
              @change="onPgidChange"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in pgOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="代采员" prop="pg_member_id">
            <el-select
              v-model="form.pg_member_id"
              filterable
              placeholder="代采员"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in pgMemberOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="次品组" prop="dgid">
            <el-select
              v-model="form.dgid"
              filterable
              placeholder="次品组"
              @change="onDgidChange"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in defectiveGroupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="次品员" prop="dg_member_id">
            <el-select
              v-model="form.dg_member_id"
              filterable
              placeholder="次品员"
              @change="handleChangeDgMemberId"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in defectiveGroupMemberOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="售后退供员" prop="as_refund_member_id" required>
            <el-select
              v-model="form.as_refund_member_id"
              filterable
              placeholder="售后退供员"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in defectiveGroupMemberOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="办公详细地址：" prop="office_address" required>
            <el-input v-model="form.office_address" disabled />
          </el-form-item>
          <el-form-item
            label="配货详细地址："
            prop="distribution_details_address"
            required
          >
            <el-input v-model="form.distribution_details_address" disabled />
          </el-form-item>
          <el-form-item label="是否异地商家" prop="supply_type">
            <el-select
              v-model="form.supply_type"
              filterable
              placeholder="是否异地商家"
            >
              <el-option
                v-for="item in supplyTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <el-form-item label="" prop="business_license">
            <div style="width: 100px; text-align: center">营业执照</div>
            <el-image
              fit="cover"
              style="width: 100px; height: 100px"
              :src="form.business_license_trans"
              :preview-src-list="[form.business_license_trans]"
            >
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="" prop="front_id_card">
            <div style="width: 100px; text-align: center">身份证（正面）</div>
            <el-image
              fit="cover"
              style="width: 100px; height: 100px"
              :src="form.front_id_card_trans"
              :preview-src-list="[form.front_id_card_trans]"
            >
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="" prop="back_id_card">
            <div style="width: 100px; text-align: center">身份证（背面）</div>
            <el-image
              fit="cover"
              style="width: 100px; height: 100px"
              :src="form.back_id_card_trans"
              :preview-src-list="[form.back_id_card_trans]"
            >
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="" prop="group_photo_trans">
            <div style="width: 100px; text-align: center">档口门头照：</div>
            <el-image
              fit="cover"
              style="width: 100px; height: 100px"
              :src="form.door_head_photo_trans"
              :preview-src-list="[form.door_head_photo_trans]"
            >
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="" prop="group_photo_trans">
            <div style="width: 100px; text-align: center">档口开单小票：</div>
            <el-image
              fit="cover"
              style="width: 100px; height: 100px"
              :src="form.billing_receipt_photo_trans"
              :preview-src-list="[form.billing_receipt_photo_trans]"
            >
            </el-image>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.status === constantMap.STATUS.PENDING">
        <div style="text-align: center; padding-bottom: 100px">
          <el-button type="primary" @click="showPassConfirm">通过</el-button>
          <el-button type="danger" @click="showRejectDialog">驳回</el-button>
        </div>
      </el-row>
    </el-form>
    <el-dialog
      title="提示"
      :visible.sync="rejectDialogVisible"
      :before-close="onRejectDialogClose"
    >
      <div style="text-align: center; margin-bottom: 20px">
        选择后将驳回商家申请，确认吗？
      </div>
      <el-form label-position="left" label-width="60px">
        <el-form-item label="原因：">
          <el-input v-model="rejectNote" type="textarea" rows="4" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="rejectDialogVisible = false"> 取 消</el-button>
        <el-button type="primary" @click="handleReject">确定</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>
<script>
import {
  postGetFind,
  postGetGroupMemberByMarket,
  postPass,
  postReject,
} from "@/openapi/erp/supplyDocumentDraft.js";
import rules from "@/const/rules.js";
import {
  postCheckShop,
  postGetMainMarket,
  postGetBaobShopList,
  getGetAttributableMarketList,
  postGetChildMarket,
} from "@/openapi/erp/supply.js";
import {
  getSelectPg,
  postGetDgGroup,
  postGetPgMember,
} from "@/openapi/erp/common.js";
import { postGetGroupMember } from "@/openapi/erp/defective.js";

const constantMap = {
  isJoinProfit: "1", // 参与折扣让利
  isNotJoinProfit: "2", // 不参与折扣让利
  deductByGoods: "1", // 待采单抵扣
  pickerOptions: {
    disabledDate: (date) => date.getTime() < Date.now(),
  },
  offsiteOptions: [
    {
      value: "1",
      label: "是",
    },
    {
      value: "2",
      label: "否",
    },
  ],
  // 营业类型{0:未知,1:独立工作室;2:线下档口;3:工厂;4:线上店铺;}
  BUSINESS_TYPE: {
    UNKNOWN: "0",
    STUDIO: "1",
    OFFLINE: "2",
    FACTORY: "3",
    ONLINE: "4",
  },
  // {0:未知,1:广州,2:杭州,3:深圳，4：青岛}
  CITY_TYPE: {
    GUANGZHOU: "1",
    HANGZHOU: "2",
    SHENZHEN: "3",
    QINGDAO: "4",
  },
  STATUS: {
    DRAFT: "1",
    PENDING: "2",
    PASSED: "3",
    REJECTED: "4",
  },
};

export default {
  data() {
    return {
      rejectNote: "", // 驳回备注
      rejectDialogVisible: false, // 驳回弹窗
      pgOptions: [], // 代采组列表
      pgMemberOptions: [], // 代采员列表
      msOptions: [], // 买手组列表
      msMemberOptions: [], // 买手列表
      defectiveGroupOptions: [], // 次品组列表
      defectiveGroupMemberOptions: [], // 次品组员列表
      refundMemberOptions: [], // 售后退供员列表
      marketList: [], // 主市场列表
      subMarketList: [], // 子市场列表
      performanceMarketList: [], // 业绩归属市场列表
      citys: [
        {
          value: constantMap.CITY_TYPE.UNKNOWN,
          label: "未知",
        },
        {
          value: constantMap.CITY_TYPE.GUANGZHOU,
          label: "广州",
        },
        {
          value: constantMap.CITY_TYPE.HANGZHOU,
          label: "杭州",
        },
        {
          value: constantMap.CITY_TYPE.SHENZHEN,
          label: "深圳",
        },
        {
          value: constantMap.CITY_TYPE.QINGDAO,
          label: "青岛",
        },
      ],
      supplyTypes: [
        {
          value: "1",
          label: "本地商家",
        },
        {
          value: "2",
          label: "异地商家",
        },
      ],
      business_type: [
        {
          value: constantMap.BUSINESS_TYPE.UNKNOWN,
          label: "未知",
        },
        {
          value: constantMap.BUSINESS_TYPE.STUDIO,
          label: "独立工作室",
        },
        {
          value: constantMap.BUSINESS_TYPE.OFFLINE,
          label: "线下档口",
        },
        {
          value: constantMap.BUSINESS_TYPE.FACTORY,
          label: "工厂",
        },
        {
          value: constantMap.BUSINESS_TYPE.ONLINE,
          label: "线上店铺",
        },
      ], // 经营类型
      shop_list: [], // 店铺列表
      isAvailableStore: null,
      constantMap,
      form: {
        id: "", // 申请id
        supply_manager_name: "", // 主理人名称
        supply_name: "", // 供应商名称
        brand_name: "", // 品牌名称
        city: "", // 城市id
        city_trans: "", // 城市名
        market_id: "", // 市场id
        market_sub_id: "", // 子市场id
        supply_floor: "", // 楼层
        supply_area: "", // 区域
        supplier_num: "", // 门牌号（档口号）
        registration_code: "", // 邀请码
        picker_group_id: "", // 买手组（买手组id）
        picker_group_member_id: "", // 买手（买手id）
        pgid: "", // 代采组（采购组id）
        pg_member_id: "", // 代采员（采购员id）
        dgid: "", // 次品组
        dg_member_id: "", // 次品员id
        as_refund_member_id: "", // 退供员 id
        office_address: "", // 办公详细地址
        distribution_details_address: "", // 配货详细地址
        front_id_card: "", // 身份证正面
        back_id_card: "", // 身份证反面
        business_license: "", // 营业执照
        front_id_card_trans: "", // 身份证正面-url
        back_id_card_trans: "", // 身份证反面-url
        business_license_trans: "", // 营业执照-url
        group_photo: "", // 手持合照
        shopId: "", // 爆版店铺id
        baobmobile: "", // 手机号
        status: "", // 申请状态 {1:草稿;2:待审核;3:已入驻;4:已驳回;}
        reject_note: "", // 驳回备注
        application_time: "", // 申请时间
        application_time_trans: "", // 申请时间-字符串
        business_type: "", // 营业类型 {0:未知,1:独立工作室;2:线下档口;3:工厂;4:线上店铺;}
      },
      rules: {
        supplier_num: [
          {
            required: true,
            message: "请输入档口号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "档口号最长可以输入20个字符",
            trigger: "blur",
          },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        market_id: [
          { required: true, message: "请选择市场", trigger: "change" },
        ],
        market_sub_id: [
          {
            required: true,
            message: "请选择子市场",
            trigger: "change",
          },
        ],
        attributable_market_id: [
          {
            required: true,
            message: "请选择业绩归属市场",
            trigger: "change",
          },
        ],
        pgid: [
          {
            required: true,
            message: "请选择代采组",
            trigger: "change",
          },
        ],
        pg_member_id: [
          {
            required: true,
            message: "请选择代采员",
            trigger: "change",
          },
        ],
        picker_group_id: [
          {
            required: true,
            message: "请选择买手组",
            trigger: "change",
          },
        ],
        picker_group_member_id: [
          {
            required: true,
            message: "请选择买手",
            trigger: "change",
          },
        ],
        dgid: [
          {
            required: true,
            message: "请选择次品组",
            trigger: "change",
          },
        ],
        dg_member_id: [
          {
            required: true,
            message: "请选择次品员",
            trigger: "change",
          },
        ],
        as_refund_member_id: [
          {
            required: true,
            message: "请选择售后退供员",
            trigger: "change",
          },
        ],
        limit_day: [
          {
            required: true,
            message: "请输入排单锁定天数",
            trigger: "blur",
          },
        ],
        plan_time_out_days: [rules.ruleBlur],
        is_return_profit: {
          required: true,
          message: "必选",
          trigger: "change",
        },
      },
      loading: false,
    };
  },
  mounted() {
    // 获取申请详情
    this.getFind();
    // 获取业绩归属市场列表
    this.handleGetPerformanceMarketList();
    // 获取采购组列表
    this.getSelectPgOptions();
    // 获取次品组列表
    this.getDefectiveGroupOptions();

    this.getSelectMsOptions()
  },
  methods: {
    // 子市场切换后，自动填充代采信息
    onSubMarketChange() {
      if (!this.form.market_sub_id) {
        return;
      }
      postGetGroupMemberByMarket({
        market_sub_id: this.form.market_sub_id,
      }).then((res) => {
        this.form.pgid = res.pgid;
        this.form.pg_member_id = res.pg_member_id;
        this.form.dgid = res.dgid;
        this.form.dg_member_id = res.dg_member_id;
        this.form.as_refund_member_id = res.as_refund_member_id;
        this.getMemberOptions();
        this.getDefectiveGroupMember();
      });
    },
    onRejectDialogClose() {
      this.rejectNote = "";
    },
    // 请求-通过
    handlePass() {
      postPass({ ...this.form, shop_id: this.form.shopId }).then(() => {
        this.$message.success("通过成功！");
        this.getFind();
        this.$router.push(
          `/home/supply/supplyApplyListPro?time=${Date.parse(new Date())}`
        );
      });
    },
    closeCurrentPage() {
      this.$router.go(-1);
    },
    // 打开-通过-确认弹框
    showPassConfirm() {
      this.$confirm("选择后将通过商家申请，确认吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handlePass();
      });
    },
    // 请求-驳回
    handleReject() {
      postReject({
        id: this.form.id,
        reject_note: this.rejectNote,
      }).then(() => {
        this.$message.success("驳回成功！");
        this.rejectDialogVisible = false;
        this.getFind();
        this.$router.push(
          `/home/supply/supplyApplyListPro?time=${Date.parse(new Date())}`
        );
      });
    },
    // 打开-驳回理由-弹框
    showRejectDialog() {
      this.rejectDialogVisible = true;
    },
    // 获取次品组列表
    getDefectiveGroupOptions() {
      postGetDgGroup().then((res) => {
        this.defectiveGroupOptions = res;
      });
    },
    onDgidChange() {
      this.defectiveGroupMemberOptions = [];
      this.refundMemberOptions = [];
      this.form.dg_member_id = "";
      this.form.refund_member_id = "";
      this.getDefectiveGroupMember();
    },
    // 切换次品组
    getDefectiveGroupMember() {
      console.log("getDefectiveGroupMember", this.form.dgid);
      if (!this.form.dgid) {
        return;
      }
      postGetGroupMember({
        dgid: this.form.dgid,
      }).then((res) => {
        this.defectiveGroupMemberOptions = res.member;
        this.refundMemberOptions = res.refundMember;
      });
    },
    // 选择次品员
    handleChangeDgMemberId(val) {
      // 如果未选择售后退供员同时次品员也是售后退供员，则售后退供员设置为当前次品员
      if (!this.form.refund_member_id) {
        const refundMemberOptionValues = this.refundMemberOptions.map(
          (item) => item.value
        );
        if (refundMemberOptionValues.includes(this.form.dg_member_id)) {
          this.form.refund_member_id = val;
        }
      }
    },
    onPgidChange() {
      this.pgMemberOptions = [];
      this.form.pg_member_id = "";
      this.getMemberOptions();
    },
    // 根据采购组id获取采购员列表
    getMemberOptions() {
      if (!this.form.pgid) {
        return;
      }
      this.loading = true;
      postGetPgMember({ pgid: this.form.pgid }).then((res) => {
        this.loading = false;
        this.pgMemberOptions = res;
      });
    },
    // 获取采购组列表
    getSelectPgOptions() {
      getSelectPg().then((res) => {
        this.pgOptions = res;
      });
    },

    // 获取买手组列表
    getSelectMsOptions() {
      this.$http.post("/erp/Common/selectPicker").then((res) => {
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.msOptions = res.data.data.map((item) => ({
          value: item.k,
          label: item.label,
        }));
      });
    },

    onMsChange() {
      this.msMemberOptions = [];
      this.form.picker_group_member_id = "";
      this.getPickerGroupMemberOption();
    },
    //  根据买手组id请求对应成员
    getPickerGroupMemberOption() {
      if(!Number(this.form.picker_group_id)) {
        return
      }
      this.loading = true;
      this.$http
        .post("/erp/Common/getPickerGroupMember", { pg_id: this.form.picker_group_id })
        .then((res) => {
          this.loading = false;
          this.msMemberOptions = res.data.data;
        });
    },

    // 切换主市场时，重新获取子市场选项
    onMainMarketChange(value, reset) {
      // 重置数据
      if (reset) {
        this.form.market_sub_id = "";
        this.subMarketList = [];
      }
      this.getSubMarketList();
    },
    getSubMarketList() {
      postGetChildMarket({ parent_id: this.form.market_id }).then((res) => {
        this.subMarketList = res;
      });
    },
    // 根据城市获取市场列表
    getMainMarketByCity() {
      postGetMainMarket({ city: this.form.city }).then((res) => {
        this.marketList = res;
      });
    },
    // 选择城市-联动获取市场列表
    handleSelectCity(value, reset) {
      // 重置数据
      if (reset) {
        this.form.market_id = "";
        this.form.market_sub_id = "";
        this.marketList = [];
        this.subMarketList = [];
      }
      this.getMainMarketByCity();
      // this.getDefectiveGroupOptionsByCity(value);
    },
    // 根据城市获取次品组列表
    // getDefectiveGroupOptionsByCity(val) {
    //   postGetCityGroups({
    //     city: val,
    //   }).then((res) => {
    //         this.form.dgid = "0";
    //         this.form.dg_member_id = "0";
    //         this.defectiveGroupOptions = res.group;
    //         this.defectiveGroupMemberOptions = [];
    //         this.refundMemberOptions = [];
    //     });
    // },
    // 主要接口-获取申请详情
    getFind() {
      postGetFind({ id: this.$route.params.id }).then((resp) => {
        this.form = resp;
        // 获取动态的市场选项（表单回显）
        this.getMainMarketByCity();
        this.getSubMarketList();
        this.getMemberOptions();
        // 获取次品组员列表
        this.getDefectiveGroupMember();

        
          this.getPickerGroupMemberOption()
      });
    },
    // 校验店铺信息
    async verifyShopInfo() {
      if (!this.form.shopId) {
        this.$message.error("请选择爆版店铺");
        this.isAvailableStore = false;
        return false;
      }
      return postCheckShop({ shopId: this.form.shopId })
        .then(() => {
          this.isAvailableStore = true;
          return true;
        })
        .catch(() => {
          this.isAvailableStore = false;
          return false;
        });
    },
    // 根据手机号（老板）获取店铺列表
    getShopList() {
      this.loading = true;
      postGetBaobShopList({
        baobmobile: this.form.baobmobile.trim(),
        supply_id: null,
      }).then((res) => {
        this.shop_list = res.shop_list;
      });
    },
    // 设置业绩归属市场
    handleSetAttributableSubMarket(attributableMarketId, reset) {
      const selectedMainMarket = this.performanceMarketList.find(
        (option) => option.attributable_market_id === attributableMarketId
      );
      this.performanceSubMarketList = selectedMainMarket?.sub_list || [];
      if (
        reset ||
        !this.performanceSubMarketList.length ||
        this.form.attributable_market_sub_id.toString() === "0"
      ) {
        this.form.attributable_market_sub_id = "";
      }
    },
    // 获取业绩归属市场列表
    handleGetPerformanceMarketList() {
      getGetAttributableMarketList()
        .then((res) => {
          this.performanceMarketList = res;
        })
        .catch(this.$noop);
    },
  },
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyDetail.vue